(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  class TabbedContentComponent extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.tabbed-content__tab');
      this.panels = this.querySelectorAll('.tabbed-content__panel');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.tabIndex;
          this.activateTab(index);
        });
      });
    }

    activateTab(index) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabIndex === index;
        tab.classList.toggle('tabbed-content__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.panelIndex === index;
        panel.classList.toggle('tabbed-content__panel--active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  customElements.define('tabbed-content-component', TabbedContentComponent);

  } catch(e) { console.error(e); }
})();
})();
